import { useState } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";

const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };

const IMG = {
  pinky: "/images/characters/pinky.webp",
  dottie: "/images/characters/dottie.webp",
  misty: "/images/characters/misty.webp",
  minty: "/images/characters/minty.webp",
  sunny: "/images/characters/sunny.webp",
  logo: "/images/logo.webp",
};

const RainbowHeading = ({ children, size = 28, tag = "h2" }) => {
  const s = {
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  };
  if (tag === "h1") return <h1 style={s}>{children}</h1>;
  if (tag === "h3") return <h3 style={s}>{children}</h3>;
  return <h2 style={s}>{children}</h2>;
};

const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Merch" ? C.pink : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Merch" ? C.pinkSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>
            Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS
          </div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 - 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>
        &copy; 2026 The Funky Bunch Kent. All rights reserved.
      </div>
    </div>
  </footer>
);

const characters = [
  { name: "Pinky Pop", img: IMG.pinky, color: C.pink, soft: C.pinkSoft },
  { name: "Sunny Ray", img: IMG.sunny, color: C.yellow, soft: C.yellowSoft },
  { name: "Dottie", img: IMG.dottie, color: C.blue, soft: C.blueSoft },
  { name: "Minty Wiggle", img: IMG.minty, color: C.mint, soft: C.mintSoft },
  { name: "Misty Cloud", img: IMG.misty, color: C.lilac, soft: C.lilacSoft },
];

export default function MerchPage() {
  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes idleWobble {
          0%, 100% { transform: rotate(0deg) scaleX(1) scaleY(1); }
          20% { transform: rotate(-3deg) scaleX(1.02) scaleY(0.98); }
          50% { transform: rotate(3deg) scaleX(0.98) scaleY(1.02); }
          80% { transform: rotate(-2deg) scaleX(1.01) scaleY(0.99); }
        }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        button:hover { transform: scale(1.03); transition: transform 0.2s; }
      `}</style>

      <Nav />

      {/* Hero */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, #FFF0F5 40%, #F0EAFF 70%, #E8F5FF 100%)`,
        padding: "48px 24px 40px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={32} tag="h1">The Funky Bunch Merch</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 16, color: C.ink + "aa",
            lineHeight: 1.6, margin: "12px auto 0", maxWidth: 480,
          }}>
            Wear the fun! Official The Funky Bunch merchandise is on its way.
          </p>
        </div>
      </section>

      {/* Coming Soon */}
      <section style={{ padding: "48px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <div style={{
            background: `linear-gradient(135deg, ${C.pinkSoft}, ${C.lilacSoft}, ${C.yellowSoft})`,
            borderRadius: 28, padding: "48px 36px",
            border: `2px solid ${C.pink}20`,
          }}>
            {/* Characters floating */}
            <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 28, flexWrap: "wrap" }}>
              {characters.map((c, i) => (
                <div key={i} style={{
                  width: 80, height: 80,
                  animation: `float 3s ease-in-out infinite`,
                  animationDelay: `${i * 0.4}s`,
                }}>
                  <img src={c.img} alt={c.name} style={{
                    width: "100%", height: "100%", objectFit: "contain",
                    filter: "drop-shadow(0 4px 10px rgba(0,0,0,0.08))",
                  }} />
                </div>
              ))}
            </div>

            <div style={{
              display: "inline-block", background: C.yellow,
              color: C.ink, padding: "6px 20px", borderRadius: 20,
              fontFamily: heading, fontWeight: 700, fontSize: 13,
              letterSpacing: 1, textTransform: "uppercase", marginBottom: 16,
            }}>Coming Soon</div>

            <h2 style={{
              fontFamily: heading, fontSize: 28, fontWeight: 800,
              color: C.ink, marginBottom: 12,
            }}>Something exciting is in the works!</h2>

            <p style={{
              fontFamily: body, fontSize: 15, color: C.ink + "99",
              lineHeight: 1.7, marginBottom: 24, maxWidth: 480, margin: "0 auto 24px",
            }}>
              We are working on a range of The Funky Bunch goodies so your little dancers can take the fun home with them. Think t-shirts, stickers and more, all featuring your favourite characters!
            </p>

            <p style={{
              fontFamily: body, fontSize: 14, color: C.ink + "77",
              lineHeight: 1.6, marginBottom: 28,
            }}>
              Follow us on social media to be the first to know when our merch drops.
            </p>

            <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
              <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer" style={{
                background: C.blue, color: "#fff", border: "none",
                padding: "12px 28px", borderRadius: 50,
                fontFamily: heading, fontWeight: 700, fontSize: 14,
                cursor: "pointer", textDecoration: "none",
                display: "inline-flex", alignItems: "center", gap: 8,
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                Follow on Facebook
              </a>
              <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer" style={{
                background: C.pink, color: "#fff", border: "none",
                padding: "12px 28px", borderRadius: 50,
                fontFamily: heading, fontWeight: 700, fontSize: 14,
                cursor: "pointer", textDecoration: "none",
                display: "inline-flex", alignItems: "center", gap: 8,
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                Follow on Instagram
              </a>
            </div>
          </div>

          {/* Teaser items */}
          <div style={{ marginTop: 40 }}>
            <RainbowHeading size={22}>What to expect</RainbowHeading>
            <div style={{ height: 20 }} />
            <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
              {[
                { item: "T-Shirts", desc: "Dance in style with your favourite character", color: C.pink, soft: C.pinkSoft, emoji: "👕" },
                { item: "Stickers", desc: "Collect all five of The Funky Bunch", color: C.blue, soft: C.blueSoft, emoji: "⭐" },
              ].map((m, i) => (
                <div key={i} style={{
                  flex: "1 1 180px", maxWidth: 200,
                  background: m.soft, borderRadius: 20,
                  padding: "24px 16px", textAlign: "center",
                  border: `2px solid ${m.color}25`,
                }}>
                  <div style={{
                    width: 48, height: 48, borderRadius: "50%",
                    background: m.color + "30", display: "flex",
                    alignItems: "center", justifyContent: "center",
                    margin: "0 auto 12px", fontSize: 22,
                  }}>
                    {m.emoji}
                  </div>
                  <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 15, color: C.ink, marginBottom: 4 }}>{m.item}</div>
                  <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.5 }}>{m.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{
        background: `linear-gradient(135deg, ${C.pinkSoft}, ${C.lilacSoft}, ${C.blueSoft})`,
        padding: "48px 24px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22}>Can't wait for merch?</RainbowHeading>
          <p style={{ fontFamily: body, fontSize: 14, color: C.ink + "99", margin: "8px 0 24px" }}>
            Book a class in the meantime and come dance with The Funky Bunch!
          </p>
          <button onClick={() => { window.location.hash = "classes"; }} style={{
            background: C.pink, color: "#fff", border: "none",
            padding: "14px 36px", borderRadius: 50,
            fontFamily: heading, fontWeight: 700, fontSize: 16, cursor: "pointer",
          }}>Book a Class</button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
